import _ from 'underscore';

export function update(state, payload) {
    let spread;
    if (!state) {
        spread = _.shuffle(payload.cards).map(card => card.index);
    } else {
        spread = state.spread;
    }
    return {...payload, spread: spread};
}

export function spread(state, payload) {
    return {...state, spread: state.spread.map((cardId) =>
        cardId == payload ? 'picked' : cardId),
    };
}

export function update_spread(state, payload) {
    return { ...state, spread: payload};
}



// WEBPACK FOOTER //
// ./app/reducers/deck.js